.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  font: 600 var(--text-sm) / 1 var(--font-display);
  letter-spacing: 0.01em;
}

.swatch {
  width: 12px;
  height: 12px;
  flex: none;
  box-shadow: inset 0 0 0 1px var(--rule-strong);
}

.icon {
  flex: none;
  color: var(--ink-muted);
}

.text {
  color: inherit;
}
